import dayjs from "dayjs";

/**
 * An employee's holiday on the date(s) being scheduled, split by approval: an approved
 * day (or one added before holiday requests existed) blocks scheduling; a request still
 * waiting for approval only warns, with an Approve button in the check-failure modal.
 * `dates` is one date, or a list of "DD/MM/YYYY" strings (reassigning checks several duties).
 */
export const holidayChecks = (emp, dates) => {
    const days = Array.isArray(dates) ? dates : [dayjs(dates).format("DD/MM/YYYY")];
    const rows = (emp?.employeeHolidayDetail || []).filter((eh) => days.includes(dayjs(eh?.holidayDate).format("DD/MM/YYYY")));
    const approved = rows.find((eh) => eh?.status !== "pending");
    const pending = rows.find((eh) => eh?.status === "pending");
    return {
        empHolidayCheck: !!approved,
        empPendingHoliday: pending && !approved
            ? { requestId: pending.requestId, employeeId: emp?._id, holidayType: pending.holidayType, date: dayjs(pending.holidayDate).format("DD/MM/YYYY") }
            : null,
    };
};
